import type { Language } from '@/shared/entities/Language'

export class MealTiersEntity{
  id?: number;
  iconUrl?: string | null;
  translations?: Array<{
    name: string
    language: Language
  }>
}
  